import stripeActionConstants from '../constants/stripeActionConstants';

const initialState = {
  customer: {},
  customerError: null,
  loading: false,
};

const stripeReducer = (state = initialState, action) => {
  switch (action.type) {
    case stripeActionConstants.GET_CUSTOMER:
      return {
        ...state,
        customer: {},
        customerError: null,
        loading: true,
      };
    case stripeActionConstants.GET_CUSTOMER_SUCCESS:
      return {
        ...state,
        customer: action.payload,
        loading: false,
      };
    case stripeActionConstants.GET_CUSTOMER_ERROR:
      return {
        ...state,
        customerError: action.payload,
        loading: false,
      };
    case stripeActionConstants.UPDATE_CUSTOMER_PAYMENT_METHOD:
      return {
        ...state,
        loading: true,
        customer: {},
        customerError: null,
      };
    case stripeActionConstants.UPDATE_CUSTOMER_PAYMENT_METHOD_SUCCESS:
      return {
        ...state,
        loading: false,
        customer: action.payload,
      };
    case stripeActionConstants.UPDATE_CUSTOMER_PAYMENT_METHOD_ERROR:
      return {
        ...state,
        loading: false,
        customerError: action.payload,
      };

    default:
      return state;
  }
};

export default stripeReducer;
